const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillrule: "evenodd",
      fill: "rgba(237, 108, 2, 1)",
      fillOpacity: 1
    },
    d: "M 7 0.0117188 C 10.847656 0.0117188 13.964844 1.4375 13.964844 3.191406 C 13.964844 4.949219 10.84375 6.371094 7 6.371094 C 3.152344 6.371094 0.0351562 4.949219 0.0351562 3.191406 C 0.0351562 1.4375 3.152344 0.0117188 7 0.0117188 Z M 0.0351562 10.652344 L 0.0351562 13.09375 C 1.273438 17.386719 13.515625 16.554688 13.964844 12.871094 L 13.964844 10.433594 C 13.355469 14.476562 1.015625 14.769531 0.0351562 10.652344 Z M 0 4.296875 L 0 6.679688 C 1.238281 10.871094 13.550781 10.304688 14 6.710938 L 14 4.328125 C 13.386719 8.277344 0.980469 8.316406 0 4.296875 Z M 0 7.375 L 0 9.816406 C 1.238281 14.109375 13.550781 13.53125 14 9.847656 L 14 7.410156 C 13.386719 11.453125 0.980469 11.496094 0 7.375 Z M 0 7.375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSecurity);
export default __webpack_public_path__ + "static/media/dataSecurity.2e114c7222f1a669aded7643c2d11a37.svg";
export { ForwardRef as ReactComponent };